import { Injectable, inject } from '@angular/core';
import { LogService } from '../../log/log.service';
import { CommunicationCoreService } from '../communication-core/communication-core.service';

export interface FunctionBlockFunctionRequest {
  requestId: string;
  name: string;
  request: any;
}

@Injectable({
  providedIn: 'root',
})
export class CommunicationSendService {
  private readonly communicationCoreService = inject(CommunicationCoreService);
  private readonly logService = inject(LogService);


  /**
   * Trigger an action for a functionblock
   * @param action name of the action to trigger
   * @param devId id of the device
   * @param networkDevId id of the network device
   * @param fbId id of the functionblock
   */
  setFunctionBlockAction(
    action: string,
    ubieId: string,
    networkDeviceId: string,
    functionBlockId: string,
    properties?: any,
  ): void {
    const topic = `cloudapp/${ubieId}/${networkDeviceId}/${functionBlockId}/setState`;

    // Prepare command to send
    const status = new StatusCommand(functionBlockId, 'action');
    status.action = action;
    // add properties to the action if properties were defined
    if (properties) {
      status.properties = properties;
    }

    this.communicationCoreService.publish(
      topic,
      JSON.stringify(status),
      ubieId,
    );
  }

  setFunctionBlockState(
    properties: any,
    ubieId: string,
    networkDeviceId: string,
    functionBlockId: string,
  ): Promise<void> {
    const topic = `cloudapp/${ubieId}/${networkDeviceId}/${functionBlockId}/setState`;

    this.logService.debug(
      'DEVICECOMMUNICATION.SERVICE - setFunctionBlockState',
    );

    // Prepare command to send
    const status = new StatusCommand(functionBlockId, 'state');
    status.properties = properties;

    return this.communicationCoreService.publish(
      topic,
      JSON.stringify(status),
      ubieId,
    );
  }

  /**
   * Call to request the lastest config for a fb
   */
  getLogQuery(
    ubieId: string,
    networkDeviceId: string,
    functionBlockId: string,
    query: any,
  ): void {
    const topic = `cloudapp/${ubieId}/${networkDeviceId}/${functionBlockId}/logQuery`;

    this.logService.info(
      'DEVICECOMMUNICATION.SERVICE - getLogQuery ' + topic,
      query,
    );

    this.communicationCoreService.publish(topic, JSON.stringify(query), ubieId);
  }

  sendFunctionBlockFunctionRequest(
    request: FunctionBlockFunctionRequest,
    ubieId: string,
    networkDeviceId: string,
    functionBlockId: string,
  ): void {
    const topic = `cloudapp/${ubieId}/${networkDeviceId}/${functionBlockId}/functionRequest`;

    this.logService.info(
      'DEVICECOMMUNICATION.SERVICE - sendFunctionBlockFunctionRequest ' + topic,
      request,
    );

    this.communicationCoreService.publish(
      topic,
      JSON.stringify(request),
      ubieId,
    );
  }

  sendActivateNetworkDeviceCommand(
    ubieId: string,
    networkDeviceId: string,
  ): void {
    const topic = `cloudapp/${ubieId}/${networkDeviceId}/setState`;

    const statusCommand: StatusCommand = {
      id: networkDeviceId,
      type: 'action',
      action: 'activate',
      sourceId: '',
    };

    this.communicationCoreService.publish(
      topic,
      JSON.stringify(statusCommand),
      ubieId,
    );
  }
}

/**
 * Status command to send via mqtt
 */
class StatusCommand {
  id: string;
  sourceId: string;
  type: string;
  action?: string;
  properties?: Array<string>;

  constructor(id: string, type: string) {
    this.id = id;
    this.type = type;
    this.sourceId = '';
  }
}
